import React from 'react';
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver';

export const localeRender = (key = '', name: string = 'Global') => (
  <LocaleReceiver componentName={name}>{(s) => (s ? s[key] : '') || key}</LocaleReceiver>
);
